import {
  Button,
  FormControl,
  HStack,
  Input,
  InputGroup,
  Stack,
  Text,
  VStack,
  useToast,
} from '@chakra-ui/react';
import React, { useState } from 'react';

import axios from 'axios';
import useLanguage from '../../hooks/useLanguage';

function Newsletter() {
  const isEnglish = useLanguage();

  const toast = useToast();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      email: email,
      listIds: [5],
      updateEnabled: true,
    };

    try {
      await axios.post('https://api.brevo.com/v3/contacts', payload, {
        headers: {
          'api-key':
            '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',
          'Content-Type': 'application/json',
        },
      });

      toast({
        status: 'success',
        title: isEnglish ? "You are now subscribed!" : 'Успешно сте се пријавили!',
      });

      setEmail('');
    } catch (error) {
      toast({
        status: 'error',
        title: isEnglish ? "There was a problem. Please try again later." : 'Настао је проблем. Молимо вас, покушајте поново.',
        // description: error.response?.data?.message || error.message,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Stack
      flexFlow={{ base: 'column', md: 'row' }}
      backgroundColor="rawSienna.500"
      borderRadius="10px"
      padding={{ base: '24px 16px 24px 16px', lg: '24px 36px 24px 36px' }}
      justifyContent="space-between"
      gap={{ lg: '16px', '2xl': '8rem !important' }}
    >
      <VStack alignItems="flex-start" gap="0px">
        <Text fontSize="20px" fontWeight="700" color="white !important">
          {isEnglish ? "Subscribe for our newsletter" : "Пријавите се на наш билтен"}
        </Text>
        <Text
          pb={{ base: '16px', lg: '0px' }}
          fontSize="16px"
          color="white !important"
        >
          {isEnglish ? "Stay updated about news, events and resources." : "Будите у току са најновијим вестима, догађајима и ресурсима."}

        </Text>
      </VStack>
      <form onSubmit={handleSubmit}>
        <HStack
          gap={2}
          flexDir={{ base: 'column', md: 'row', lg: 'row', xl: 'row' }}
          alignItems="flex-start"
        >
          <FormControl flex={1}>
            <InputGroup>
              <Input
                id="email"
                type="email"
                name="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                w={{ base: '100%', md: '100%', lg: '416px' }}
                maxW="100%"
                textColor="gunPowder.300"
                fontWeight="500"
                borderColor="#EEEDF1"
                focusBorderColor="white"
                borderRadius="full"
                bg="#fff"
                h="48px"
                placeholder={isEnglish ? "Email" : "Имејл адреса"}
                autoComplete="on"
              />
            </InputGroup>
          </FormControl>
          <Button
            variant="outlineWhite"
            w={{ base: '100%', md: 'auto' }}
            type="submit"
            isLoading={loading}
          >
            {isEnglish ? "Subscribe" : "Пријавите се"}
          </Button>
        </HStack>
      </form>
    </Stack>
  );
}

export default Newsletter;
